<template>
    <div style="overflow: hidden; width: 100%; height:  calc(100vh - 85px);">
        <!-- <vxe-button status="primary" @click="pushEvent">新增（尾部）</vxe-button> -->
        <!-- <vxe-button status="primary" @click="insertEvent">新增（第三行插入）</vxe-button> -->
        <!-- <vxe-button status="success" @click="getInsertEvent">获取新增的数据</vxe-button> -->
        <div style="display: flex;background-color: #fff; position: relative; padding: 10px;">
            <!-- 增加 -->
            <vxe-button status="primary" size="medium" icon="vxe-icon-add-users" @click="addEvent">{{ $t('button.add')
                }}</vxe-button>
            <!-- 刷新 -->
            <vxe-button style="background-color: brown;color: aliceblue;" size="medium" icon="vxe-icon-refresh"
                @click="getListData">{{ $t('button.refresh') }}</vxe-button>
            <vxe-toolbar ref="toolbarRef" custom style="position: absolute; right: 2px;">
            </vxe-toolbar>
        </div>

        <vxe-table border class="table-style" show-overflow keep-source height="auto" ref="tableRef" align="center"
            :edit-config="editConfig" :row-config="{ height: 30, isCurrent: true }" :data="tableData" :custom-config="{immediate:true}">
            <vxe-column type="seq" width="70"></vxe-column>
            <vxe-column field="roleName" title="角色名称"
                :edit-render="{ name: 'VxeInput', props: { size: 'mini' } }"></vxe-column>
            <!-- <vxe-column field="roleName" title="角色名称"  :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input size="mini" v-model="row.roleName" clearable></vxe-input>
                </template>
<template #default="{ row }">
                    <span>{{ row.roleName }}</span>
                </template>
</vxe-column> -->
            <vxe-column field="roleDes" title="角色职责"
                :edit-render="{ name: 'VxeInput', props: { size: 'mini' } }"></vxe-column>
            <vxe-column title="操作" width="250">
                <template #default="{ row }">
                    <vxe-button mode="text" status="error" icon="vxe-icon-edit" @click="revertRow(row)">恢复</vxe-button>
                    <vxe-button mode="text" status="success" icon="vxe-icon-save" @click="saveRow(row)">保存</vxe-button>
                    <vxe-button mode="text" status="warning" icon="vxe-icon-add-user"
                        @click="assignPer(row)">分配权限</vxe-button>
                </template>
            </vxe-column>
        </vxe-table>
        <vxe-modal v-model="showauth" title="分配权限" :width="1000" height="80vh" esc-closable>
            <!-- <vxe-checkbox-group v-model="hobbiesList" style="display: flex;justify-content: center;">
                <vxe-checkbox v-for="item in options" :label="item.value" :content="item.label" ></vxe-checkbox>                            
            </vxe-checkbox-group> -->
                <el-tree :data="hobbiesList" ref="tree"  show-checkbox node-key="id" :default-expand-all="false"
                    :default-checked-keys="defaultcheck">
                </el-tree>
            <!-- style="display: flex;justify-content: center;margin-top: 1vh;" -->
            <div class="save_button" >
                <vxe-button status="primary" content="保存确认" @click="saveAndEdit()"></vxe-button>
            </div>
        </vxe-modal>
    </div>
</template>

<script>
export default {
    name: 'staffManagement',
    data() {
        const editConfig = {
            trigger: 'click',
            mode: 'cell',
            showStatus: true
        }
        return {
            defaultcheck: [],//默认选中
            editConfig,
            tableData: [],
            showauth: false,
            options: [],
            // },
            // formData: {
            hobbiesList: [],
            username: '',
        }
    },
    mounted() {
        const $table = this.$refs.tableRef
        const $toolbar = this.$refs.toolbarRef
        if ($table && $toolbar) {
            $table.connect($toolbar)
        }
    },
    created() {
        this.getListData();
    },
    methods: {
        // 保存
        saveAndEdit() {
            const checkedHalfKeys = this.$refs.tree.getHalfCheckedKeys();
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            let concatCheckedKeys = checkedHalfKeys.concat(checkedKeys);
            this.$api.updateModuleByRole( this.username,concatCheckedKeys ).then(res =>{
                this.$message.success('保存更新成功');
                this.getListData();
            })
            this.showauth = false;
        },
        assignPer(row) {
            this.username = row.roleName;
            this.hobbiesList = [];
            this.$api.getModuleList( {roleName:row.roleName} ).then(res =>{
                this.hobbiesList = res.data;
                this.showauth = true;
                let obj = JSON.parse(JSON.stringify(res.data));
                this.defaultcheck = [];
                obj.forEach((item, index) => {
                    this.traverseTree(item, this.defaultcheck);
                });
            })

        },
        traverseTree(node, result) {
            if (node.isSelected === 1) {
                result.push(node.id); // 如果 isSelected 为 1，将 id 添加到结果中
            }
            if (node.children && node.children.length > 0) {
                node.children.forEach(child => {
                    this.traverseTree(child, result); // 递归遍历子节点
                });
            }
        },

        saveRow(row) {
            this.$api.insRole( row ).then(res =>{
                this.$message.success( row.id ? '保存成功' : '修改成功');
                this.getListData();
            })
        },
        getListData() {
            this.$api.getRoleList( ).then(res =>{
                this.tableData = res;
            })
        },
        revertRow(row) {
            const $table = this.$refs.tableRef
            if ($table) {
                if ($table.isUpdateByRow(row)) {
                    $table.revertData(row)
                    VxeUI.modal.message({
                        content: '数据已恢复',
                        status: 'success'
                    })
                } else {
                    VxeUI.modal.message({
                        content: '数据未改动',
                        status: 'info'
                    })
                }
            }
        },
        async addEvent() {
            const $table = this.$refs.tableRef
            if ($table) {
                const record = {
                    name: `Name_${new Date().getTime()}`
                }
                const { row: newRow } = await $table.insert(record)
                $table.setEditRow(newRow)
            }
        },
    },
}
</script>

<style lang="css" scoped>
.save_button{
    height: 40px;
    position: absolute;
    bottom: 20px;
    right: 50px;
}
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .vxe-toolbar {
    padding: 0px;
}
</style>